import { type HTMLReactParserOptions, parse } from '@/libs/htmlReactParser';

/**
 * Utility function para fazer parse de HTML string para React elements
 * @param html - String HTML para ser parseada
 * @param options - Opções customizadas do html-react-parser
 * @returns React elements
 */
export function parseHtml(html: string, options?: HTMLReactParserOptions) {
  if (!html) return null;
  return parse(html, options);
}
